import { Injectable, inject } from '@angular/core';
import { StorageService } from './storage.service';
import { UserInfo } from '../domain/user-info';

@Injectable({ providedIn: 'root' })
export class SecurityService {
  private storage = inject(StorageService);

  async getUser(): Promise<UserInfo | null> {
    return this.storage.get<UserInfo>('authUser');
  }
}
